import moment from 'moment'
import QueryString from 'query-string'

export function defaultOrQueryFromDate(query) {
  let from = moment().subtract(1, 'day')
  if (query && query.from) {
    from = moment(query.from)
  }
  return from
}

export function defaultOrQueryToDate(query) {
  let to = moment()
  if (query && query.to) {
    to = moment(query.to)
  }
  return to
}

export function defaultOrQueryDate(query) {
  const parsed = QueryString.parse(query)
  return [defaultOrQueryFromDate(parsed), defaultOrQueryToDate(parsed)]
}

export function defaultOrQueryLimit(query = {}) {
  const { limit } = query
  return limit || 20
}
